import { index, snakeCase, text, timestamp, varchar } from 'drizzle-orm/pg-core'
import { id, timestamps } from '../utils/columns.helpers'
import { benefitsTable } from './benefits.table'
import { clientsTable } from './clients.table'
import { usersTable } from './users.table'
import { vendorsTable } from './vendors.table'

export const benefitClaimsTable = snakeCase.table(
    'benefit_claims',
    {
        id: id('bcl'),
        benefitId: text()
            .notNull()
            .references(() => benefitsTable.id, {
                onDelete: 'cascade',
                onUpdate: 'cascade',
            }),
        employeeId: text()
            .notNull()
            .references(() => usersTable.id, {
                onDelete: 'cascade',
                onUpdate: 'cascade',
            }),
        clientId: text().references(() => clientsTable.id, {
            onDelete: 'cascade',
            onUpdate: 'cascade',
        }),
        vendorId: text().references(() => vendorsTable.id, {
            onDelete: 'cascade',
            onUpdate: 'cascade',
        }),
        claimCode: varchar({ length: 100 }).notNull().unique(),
        status: varchar({ length: 50 }).notNull().default('claimed'), // 'claimed' | 'redeemed' | 'expired' | 'cancelled'
        claimedAt: timestamp({ withTimezone: true }).defaultNow(),
        redeemedAt: timestamp({ withTimezone: true }),
        expiresAt: timestamp({ withTimezone: true }),
        notes: text(),
        ...timestamps,
    },
    (table) => [
        index('benefit_claims_employee_status_idx').on(
            table.employeeId,
            table.status,
        ),
        index('benefit_claims_client_status_idx').on(
            table.clientId,
            table.status,
        ),
        index('benefit_claims_vendor_status_idx').on(
            table.vendorId,
            table.status,
        ),
        index('benefit_claims_benefit_employee_idx').on(
            table.benefitId,
            table.employeeId,
        ),
        index('benefit_claims_claim_code_idx').on(table.claimCode),
        index('benefit_claims_created_at_idx').on(table.createdAt),
    ],
)
